import type { SlateValue } from './types';

export const SLATE_NODE_TYPES = {
  BLOCK: 'block',
  INLINE: 'inline',
  MARK: 'mark',
} as const;
export type SlateNodeType = (typeof SLATE_NODE_TYPES)[keyof typeof SLATE_NODE_TYPES];

export const SLATE_TEXT_FORMATS = {
  PARAGRAPH: 'paragraph',
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough',
  ALIGN_LEFT: 'left',
  ALIGN_CENTER: 'center',
  ALIGN_RIGHT: 'right',
  HEADING_ONE: 'heading-one',
  HEADING_TWO: 'heading-two',
  HEADING_THREE: 'heading-three',
  HEADING_FOUR: 'heading-four',
  HEADING_FIVE: 'heading-five',
  HEADING_SIX: 'heading-six',
  BLOCK_QUOTE: 'block-quote',
  BULLETED_LIST: 'bulleted-list',
  NUMBERED_LIST: 'numbered-list',
  LIST_ITEM: 'list-item',
  LINK: 'link',
  IMG: 'image',
  DD_VARIATION: 'dd-variation',
  PROMPT_TAG: 'prompt-tag',
  BANK_MESSAGE: 'bank-message',
  PRODUCT_DESCRIPTION: 'product-description',
  RESOURCE_URL: 'resource-url',
  PROMPT_IMAGE: 'prompt-image',
  PROMPT_DOCUMENT: 'prompt-document',
  EXTERNAL_CHANNEL_TEXT: 'external-channel-text',
  PROMPT_VARIABLE: 'prompt-variable',
  PROMPT_INSTRUCTION: 'prompt-instruction',
  PROMPT_AUDIO: 'prompt-audio',
  PROMPT_VIDEO: 'prompt-video',
} as const;
export type SlateTextFormat = (typeof SLATE_TEXT_FORMATS)[keyof typeof SLATE_TEXT_FORMATS];

export const SLATE_VOID_ELEMENT = {
  DIVIDER: 'divider',
} as const;
export type SlateVoidElement = (typeof SLATE_VOID_ELEMENT)[keyof typeof SLATE_VOID_ELEMENT];

export const SLATE_PROMPT_TAGS: SlateTextFormat[] = [
  SLATE_TEXT_FORMATS.PROMPT_TAG,
  SLATE_TEXT_FORMATS.BANK_MESSAGE,
  SLATE_TEXT_FORMATS.PRODUCT_DESCRIPTION,
  SLATE_TEXT_FORMATS.RESOURCE_URL,
  SLATE_TEXT_FORMATS.PROMPT_IMAGE,
  SLATE_TEXT_FORMATS.PROMPT_DOCUMENT,
  SLATE_TEXT_FORMATS.PROMPT_VARIABLE,
  SLATE_TEXT_FORMATS.PROMPT_INSTRUCTION,
  SLATE_TEXT_FORMATS.PROMPT_AUDIO,
  SLATE_TEXT_FORMATS.PROMPT_VIDEO,
];

export const SLATE_EDITOR_ACTION = {
  // Inline formatting actions
  toggleBold: 'toggleBold',
  toggleItalic: 'toggleItalic',
  toggleUnderline: 'toggleUnderline',
  toggleStrikethrough: 'toggleStrikethrough',
  insertLink: 'insertLink',

  // Block formatting actions
  toggleParagraph: 'toggleParagraph',
  toggleH1: 'toggleH1',
  toggleH2: 'toggleH2',
  toggleH3: 'toggleH3',
  toggleBlockQuote: 'toggleBlockQuote',
  toggleBulletedList: 'toggleBulletedList',
  toggleNumberedList: 'toggleNumberedList',

  // Alignment actions
  alignTextLeft: 'alignTextLeft',
  alignTextCenter: 'alignTextCenter',
  alignTextRight: 'alignTextRight',

  // Other actions
  undo: 'undo',
  redo: 'redo',
  clearFormat: 'clearFormat',
} as const;
export type SlateEditorAction = (typeof SLATE_EDITOR_ACTION)[keyof typeof SLATE_EDITOR_ACTION];
export const SLATE_EDITOR_ACTIONS = Object.values(SLATE_EDITOR_ACTION);

export const DEFAULT_SLATE_VALUE: SlateValue = [
  {
    type: SLATE_TEXT_FORMATS.PARAGRAPH,
    children: [{ text: '' }],
  },
];

export const EMPTY_PARAGRAPH_HTML = '<p></p>';

export const SLATE_EMPTY_SELECTION_COPY = {
  nothing: 'nothing',
  wholeContent: 'wholeContent',
} as const;
export type SlateEmptySelectionCopy =
  (typeof SLATE_EMPTY_SELECTION_COPY)[keyof typeof SLATE_EMPTY_SELECTION_COPY];
